export default {
  SET_MERCHANT_TYPES: "SET_MERCHANT_TYPES",
  SET_BANK_ACCOUNTS: "SET_BANK_ACCOUNTS",
};
